<div fxLayoutAlign="space-around center" style="padding-top: 10px;">
  <mat-card class="mat-elevation-z2" fxFlex="90">
    <mat-card-content style="background-color: #fffff8;">
      <div fxLayoutAlign="end" *ngIf="displayOpenInNewWindow">
        <a routerLink="/gestion/visualiser/{{response?.uuid}}"
           target="_blank"
           style="text-decoration: none; color: #333333;"
           matTooltip="ouvrir la demande dans une nouvelle fenêtre">
          <mat-icon class="md-icon-demi" color="primary" data-cy="icon-response-fiche-open-in-new">open_in_new</mat-icon>
        </a>
      </div>
      <mat-tab-group #matTabGroup
                     mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="selectedTabIndex"
                     (selectedTabChange)="selectedTabValue($event)"
                     >
        <!-- la visualisation de la demande -->
        <mat-tab label="{{titleTab()}}">
          <div *ngIf="responseObjs$ | async as responseObjs" class="response__fiche">
            <div fxFlex="80" fxLayout="column" fxLayoutGap="10px">
              <div *ngIf="response" fxLayoutAlign="end">
                <span [innerHTML]="stateResponseChip(response)"></span>&nbsp;
                <span [innerHTML]="stateInstructionChip(response)"></span>
              </div>
              <app-motif-message-response [response]="response"></app-motif-message-response>
              <div *ngIf="response" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayoutAlign="start center">
                  Référence de la demande : {{response.reference}}<br/>
                  Date  de dernière mise à jour : {{response?.dt_updated|date: 'dd/MM/yyyy'}}<br/>
                  Demandeur : {{response?.user_obj?.first_name}} {{response?.user_obj?.last_name}}
                  ({{response?.user_obj?.email_pro}})
                </div>
                <div *ngIf="individu && isGestionnaire" fxLayoutAlign="end center">
                  <div style="margin-right: 15px">
                    <app-download-pdf *ngIf="individu && isGestionnaire" [response]="response"></app-download-pdf>
                  </div>
                  <div>
                    <app-response-instruction-state [gestionnaireId]="gestionnaireId"
                                                    [response]="response"
                                                    [form]="response?.form_obj"
                                                    (onChangedState)="emitNewResponseStateInstruction($event)">

                    </app-response-instruction-state>
                  </div>
                </div>
              </div>
              <div fxLayout="column">
                <mat-card class="mat-elevation-z3 top__form" fxFlex="100">
                  <mat-card-title fxLayoutAlign="center">
                    <div class="form__title">
                      {{formName}}
                    </div>
                  </mat-card-title>
                </mat-card>
                  <div *ngFor="let resp of responseObjs;let i = index" class="block__container">
                    <ng-container *ngIf="resp[0]">
                      <div class="block__title">
                        <h2><span>{{ getBlockPrefixDesign(i) }}</span> {{resp[0].block_name}}</h2>
                      </div>
                      <mat-card class="mat-elevation-z0 reponse__card">

                        <ng-container *ngIf="getConditionBLock(resp) as conditionBlock">
                          <div *ngIf="conditionBlock?.is_active">
                            <label>{{ conditionBlock?.condition }}</label>
                            <mat-radio-group [value]="getConditionBLockValue(resp)?.display" class="block__condition" disabled>
                              <mat-radio-button [value]="true">{{ conditionBlock?.satisfy }}</mat-radio-button>
                              <mat-radio-button [value]="false">{{ conditionBlock?.other }}</mat-radio-button>
                            </mat-radio-group>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="getConditionBLockValue(resp)?.display">
                          <div *ngFor="let f of resp | orderBy: 'order'" class="response__container">
                            <div class="response">
                            <mat-card-title class="response__label">{{getLabel(f)}}</mat-card-title>
                              <!-- Fichier -->
                              <div *ngIf="f.field?.options_obj?.controlType === fieldType.TypeFile">
                                <p class="class__value" *ngIf="f.file && f.value">
                                  <button mat-icon-button class="download__button"
                                          color="accent"
                                          inline=true
                                          [matTooltip]="'Télécharger le fichier ' + f.value"
                                          (click)="downloadFile(f)"
                                  >
                                  <mat-icon class="download__icon" [attr.data-cy]="'icon-response-fiche-'+f.id">file_download</mat-icon>
                                  </button>
                                {{getValue(f) || "---"}}
                                <button mat-icon-button class="download__button" *ngIf="getFileExtension(f.file)"
                                        color="accent"
                                        inline=true
                                        [matTooltip]="'Voir le fichier ' + f.value"
                                        (click)="visualiser([f])"
                                >
                                  <mat-icon class="view__icon" [attr.data-cy]="'icon-response-fiche-'+f.id">visibility</mat-icon>
                                  </button>
                                </p>
                              </div>
                              <!-- textarea : on affiche le HTML -->
                            <p class="class__value" *ngIf="f.field?.options_obj?.controlType === fieldType.TypeTextarea"
                                 [innerHTML]="getValue(f) | newline"></p>
                            <p class="class__value__label" *ngIf="f.field?.options_obj?.controlType === fieldType.TypeLabel"
                                 [innerHTML]="getValueLabel(f)|safeHtml"></p>
                              <!-- type avis -->
                              <app-avis-fiche *ngIf="f.field?.options_obj?.controlType === fieldType.TypeAvis"
                                              [item]="getValue(f)"
                                              [response_state]="response?.state"
                                              [individu]="individu" [response]="response"></app-avis-fiche>
                              <!-- autre type -->
                              <p class="class__value" *ngIf="!filterTypeOfField(f)">
                              {{getValue(f) || "---"}}
                              </p>
                            </div>
                          </div>
                        </ng-container>

                      </mat-card>

                    </ng-container>
                  </div>

              </div>
            </div>
          </div>
        </mat-tab>
        <!-- block administratif paramétré si existant -->
        <mat-tab *ngIf="hasAdministrativeBlock((formModel$ | async))"
                        label="Suivi administratif">
          <div *ngIf="formModel$ | async as formModel">
            <div>
              <app-form-render
                (emitResponse)="onSubmitBlockAdmin($event)"
                [formModel]="formModel"
                [blockType]="blockType.Administratif"
                [demandeId]="response?.id"
                [submitted]="false"
              ></app-form-render>
            </div>
          </div>
        </mat-tab>
        <!-- displayOpinion-->
        <mat-tab [label]="tabLabelGiveOpinion" *ngIf="displayOpinion">
          <mat-card-subtitle style="padding-top: 10px;">
          </mat-card-subtitle>
          <app-opinion *ngIf="tabLabel === tabLabelGiveOpinion"
                       [responseUUID]="response.uuid"></app-opinion>
        </mat-tab>
        <!-- messages / échanges -->
        <mat-tab label="Messages" *ngIf="canDisplayMessages(response)" data-cy="tab-reponse-fiche-message">
          <mat-card-subtitle style="padding-top: 10px;">
            {{wordingMessagesTab()}}
          </mat-card-subtitle>
          <p8-list-comments *ngIf="selectedTabIndex === IDX_TAB_MESSAGE"
                            [object_id]="response.id"
                            [content_type]="response.content_type"
                            [canSeePrivate]="isGestionnaire"></p8-list-comments>
          <p8-comment [object_id]="response.id" [content_type]="response.content_type" [application]="application"
                      [hasPrivate]="isGestionnaire" [hasFilesToUpload]="true" [maxFiles]="1"
                      [sendMail]="true" [sendTosPrivate]="emailsGestionnaires" [sendTosPublic]="emailsAll"
                      [linkToOpenOrTitle]="this"></p8-comment>
        </mat-tab>
        <!-- Avis externes -->
        <mat-tab label="Avis" *ngIf="isGestionnaire">
          <mat-tab-group [(selectedIndex)]="selectedTabIndexAvis" mat-stretch-tabs="false" mat-align-tabs="start">
            <div *ngIf="selectedTabIndex === IDX_TAB_AVIS_EXTERNE">
              <mat-tab label="Voir les avis">
                <app-list-opinions *ngIf="response && selectedTabIndexAvis === IDX_TAB_AVIS_LIST"
                                   [response]="response"
                                   [lastInstructionState]="lastInstructionState"
                                   [displayGestionnaire]="true"></app-list-opinions>
              </mat-tab>
              <mat-tab label="Demander un avis">
                <app-request-opinion *ngIf="response && selectedTabIndexAvis === IDX_TAB_AVIS_DEMANDE"
                                     [response]="response"
                                     [lastInstructionState]="lastInstructionState"></app-request-opinion>
              </mat-tab>
            </div>
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
